import { defineComponent, onMounted, onBeforeUnmount } from 'vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import PendingDepositMobile from '@/components/buyCrypto/PendingDepositMobile.vue';
import PendingBankDeposit from '@/components/buyCrypto/PendingBankDeposit.vue';
import DepositNotFound from '@/components/buyCrypto/DepositNotFoundComponent.vue';
import { Button } from '@yellowcard/components-library-vue3';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/modules/auth';
import { KycTypes } from '@/types/kyc';
import router from '@/router';
import { TransactTypes } from '@/types/transact';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import { getChannelLabel } from '@/utils/helpers';
import { usePaymentStore } from '@/store/modules/payment';
export default defineComponent({
    name: 'OrderSent',
    components: {
        TransactHeader,
        LoaderComponent,
        Button,
        PendingDepositMobile,
        PendingBankDeposit,
        DepositNotFound,
    },
    setup() {
        const transactionStore = useTransactionsStore();
        const { loading, depositFailed, channel, currentStep, transferFound, cryptoTransferSent, selectedChannel, collection, selectedFiatAmountWithoutFees, } = storeToRefs(transactionStore);
        const authStore = useAuthStore();
        const { user, partnerRedirectEnabled, partnerRedirectLink, partnerId } = storeToRefs(authStore);
        const paymentStore = usePaymentStore();
        const kycStatus = user.value?.kycStatus;
        const { ChannelTypes } = WidgetApiServiceTypes;
        let intervalId;
        const setCollectionStatus = () => {
            transferFound.value = false;
            cryptoTransferSent.value = false;
            if (collection.value) {
                const { Status } = WidgetApiServiceTypes;
                switch (collection.value?.status) {
                    case Status.CREATED:
                    case Status.PENDING_CONFIRMATION:
                    case Status.PENDING_APPROVAL:
                    case Status.PENDING:
                    case Status.PROCESS:
                        transferFound.value = false;
                        cryptoTransferSent.value = false;
                        break;
                    case Status.PROCESSING:
                    case Status.PENDING_SETTLEMENT:
                    case Status.SETTLEMENT_PROCESSING:
                    case Status.SETTLEMENT_PENDING:
                        transferFound.value = true;
                        cryptoTransferSent.value = false;
                        break;
                    case Status.COMPLETE:
                    case Status.SETTLEMENT_COMPLETE:
                        cryptoTransferSent.value = true;
                        transferFound.value = true;
                        break;
                    case Status.EXPIRED:
                    case Status.FAILED:
                    case Status.CANCELLED:
                    case Status.REFUNDED:
                    case Status.SETTLEMENT_FAILED:
                        depositFailed.value = true;
                        break;
                    default:
                }
            }
            else {
                depositFailed.value = true;
            }
        };
        const postMessageToParentOrOpener = (messageData) => {
            // eslint-disable-next-line no-restricted-globals
            const { opener, top } = window;
            // eslint-disable-next-line no-restricted-globals
            const targetWindow = opener || top;
            if (targetWindow) {
                targetWindow.postMessage(JSON.stringify(messageData), '*');
            }
            else {
                // Handle the case where neither opener nor top is available (optional)
                console.warn('Unable to post message: No suitable target window found.');
            }
        };
        const sendEndFlowMessage = () => {
            const messageData = {
                depositMade: true,
                name: 'YCWidgetEndFlowEvent',
                depositAmount: selectedFiatAmountWithoutFees.value,
                origin: `${window.location.protocol}//${window.location.host}`,
                redirectLink: partnerRedirectLink.value,
                redirectEnabled: partnerRedirectEnabled.value,
            };
            postMessageToParentOrOpener(messageData);
        };
        onMounted(() => {
            setCollectionStatus();
            intervalId = window.setInterval(async () => {
                await transactionStore.fetchCollection();
                setCollectionStatus();
            }, 10000);
            if (partnerRedirectEnabled.value) {
                if (partnerRedirectLink.value) {
                    window.location.href = partnerRedirectLink.value;
                }
            }
            else {
                sendEndFlowMessage();
            }
            trackEvent(MIXPANEL_EVENTS.BUY.EOF, {
                payment_method: getChannelLabel(selectedChannel.value),
                partner: partnerId.value,
                success: !depositFailed.value,
            });
        });
        onBeforeUnmount(() => {
            clearInterval(intervalId);
        });
        const goHome = () => {
            trackEvent(MIXPANEL_EVENTS.BUY.MY_ACCOUNT, {
                partner: partnerId.value,
            });
            transactionStore.resetStore();
            paymentStore.resetStore();
            router.push('/');
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        return {
            loading,
            WidgetApiServiceTypes,
            depositFailed,
            channel,
            ChannelTypes,
            KycTypes,
            kycStatus,
            goHome,
        };
    },
});
